import React from 'react';

import './App.css';

import DrawingController, { DrawingCallbacks } from 'drawing/DrawingController';
import ThreejsDrawingSystem, { createFromSize } from 'drawing/threejs/ThreejsDrawingSystem';

import LSystem from 'entities/core/LSystem';
import { createFromLSystem } from 'entities/instruction/CachedLSystemInstructions';
import { SymbolToInstruction } from 'entities/instruction/LSystemInstructions';

import InputUI, { InputFields } from 'ui/input/InputUI';
import SystemList from 'ui/systemlist/SystemList';
import Threejs from 'ui/views/threejs/Threejs';
import DepthContoller from 'ui/controllers/DepthController';

const threejsDrawingSystem: ThreejsDrawingSystem = createFromSize(500, 500);

const cube: InputFields = {
    name: 'Cube',
    forward: 'F',
    axiom: 'X',
    rules: { X: 'F+F+F+F\\X' },
    angle: 90,
    step: 5,
    depth: 5,
};

const App = () => {
    const [inputFields, setInput] = React.useState<InputFields>();

    const getDrawingController = (move: number, angle: number): DrawingController => {
        const drawingSystem = threejsDrawingSystem;
        const callbacks: DrawingCallbacks = {
            forward: (): void => drawingSystem?.forward(move),
            turnLeft: (): void => drawingSystem?.turnLeft(angle),
            turnRight: (): void => drawingSystem?.turnRight(angle),
            pitchUp: (): void => drawingSystem?.pitchUp(angle),
            pitchDown: (): void => drawingSystem?.pitchDown(angle),
            tiltLeft: (): void => drawingSystem?.tiltLeft(angle),
            tiltRight: (): void => drawingSystem?.tiltRight(angle),
            setColor: (instr): void => drawingSystem?.setColor(instr),
            clear: (): void => drawingSystem?.clear(),
            push: (): void => drawingSystem?.push(),
            pop: (): void => drawingSystem?.pop(),
        };

        return new DrawingController(callbacks);
    };

    const render = (setCamera: boolean, depthOverride?: number) => {
        if (!inputFields) {
            return;
        }

        const finalDepth = depthOverride || inputFields.depth;

        const lsystem = new LSystem(inputFields.axiom, inputFields.rules);

        const symbol2Instr: SymbolToInstruction = {
            forward: Array.from(inputFields.forward),
        };

        const lsystemInstr = createFromLSystem(lsystem, finalDepth, symbol2Instr);
        threejsDrawingSystem.clear();
        getDrawingController(inputFields.step, inputFields.angle).draw(lsystemInstr);
        threejsDrawingSystem.add();
        if (setCamera) {
            threejsDrawingSystem.setCamera();
        }

        threejsDrawingSystem.render();
    };

    const adjustDepth = (newDepth: number): void => {
        if (inputFields) {
            render(false, newDepth);
            setInput({ ...inputFields, depth: newDepth });
        }
    };

    return (
        <div className="App">
            <div className="inputStyles">
                <InputUI inputFields={inputFields} setSystem={setInput} key={inputFields?.name} />

                <input type="button" value="Render" onClick={() => render(true)} />

                <SystemList setSystem={setInput} userSystems={[cube]} />
            </div>
            <Threejs drawingSystem={threejsDrawingSystem} />
            <DepthContoller adjustDepth={adjustDepth} depth={inputFields?.depth || -1} />
        </div>
    );
};

export default App;
